<template>
  <div class="tabbar-page">
    <van-tabbar :value="active" @change="changeTabbar">
      <van-tabbar-item icon="home-o" @click="
        $router.push({
          path: 'common-index',
          query: { cateId: moduleInfo.topCateId },
        })
        ">
        首页
      </van-tabbar-item>
      <van-tabbar-item icon="apps-o" @click="$router.push({
        path: 'goods-cate-list',
        query: { cateId: moduleInfo.topCateId },
      })">
        分类
      </van-tabbar-item>
      <van-tabbar-item icon="contact-o" @click="$router.push({ path: 'user-center-index' })" class="budo-18"> 我的 </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  name: "tabbar-drama",

  data() {
    return {
      // active: 0,
      moduleInfo: this.get_mall_module(),
    };
  },

  props: {
    active: { type: Number, default: 0 },
  },

  computed: {
    goodsCount: function () {
      const cart = this.$store.getters.cart;
      if (cart && Array.isArray(cart) && cart.length > 0) {
        return cart.length;
      }
      return 0;
    },
  },

  created() {
    budo_log.info("#40 tabbar-drama created", this.moduleInfo);
  },

  methods: {
    changeTabbar(index) {
      budo_log.info("#48 changeTabbar", index);
    },

    toGoodList(path) {
      budo_log.info("#46 toGoodList", this.$route.name);
      if (this.$route.name != path) {
        this.$router.push({ path });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "index";
</style>
